import * as React from 'react';
import Box from '@mui/material/Box';
import Fab from '@mui/material/Fab';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import SearchIcon from '@mui/icons-material/Search';
import Modal from '@mui/material/Modal';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import Button from 'react-bootstrap/Button';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import Grid from '@mui/material/Grid';

 function TasksControls(props) {

    const styles = {fab: {':hover': {bgcolor: 'var(--orange);',
                                     color: 'var(--white);'}},
                    modalBox: { position: 'absolute',
                                top: '50%',
                                left: '50%',
                                transform: 'translate(-50%, -50%)',
                                width: 400,
                                bgcolor: 'background.paper',
                                border: '2px solid #000',
                                boxShadow: 24,
                                p: 4}
                    }

    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const [titulo, setTitulo] = React.useState('');
    const [descripcion, setDescipcion] = React.useState('');
    const [fechaEntrega, setFechaEntrega] = React.useState(new Date());
    const [time, setTime] = React.useState();

    const handleChangeTitulo = (e) => {
        setTitulo(e.target.value);
    }

    const handleChangeDescripcion = (e) => {
        setDescipcion(e.target.value);
    }

    const handleChangeEntrega = (newValue) => {
        setFechaEntrega(newValue);
    };

    const handleChangeTime = (newValue) => {
        setTime(newValue);
    };

    const createTarea = async () => {
        await fetch(`${props.url}/procesos-api/task`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Token '+ localStorage.getItem('token'),
              },
              body: JSON.stringify({
                  
              })
        })
    }

    return (
        <React.Fragment>
            <Box sx={{ '& > :not(style)': { m: 1 } }}>
                <Fab size="small" aria-label="search" sx={styles.fab}>
                    <SearchIcon />
                </Fab>
                <Fab size="small" aria-label="edit"  sx={styles.fab}>
                    <EditIcon />
                </Fab>
                <Fab size="small" aria-label="add"  sx={styles.fab} onClick={handleOpen}>
                    <AddIcon />
                </Fab>
            </Box>

            <Modal open={open}
                   onClose={handleClose}>
                <Box className="ad--task-modalBox" sx={styles.modalBox}>
                <FormControl fullWidth>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}><div >Agregar tarea</div></Grid>
                        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                            <TextField className="add-task" placeholder='Nombre de la tarea' variant="filled"
                                        onChange={handleChangeTitulo}
                            />
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                            <TextField className="add-task" placeholder='Descripción' variant="filled"
                                        onChange={handleChangeDescripcion}
                            />
                        </Grid>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                                <DesktopDatePicker label="Desde" inputFormat="MM/dd/yyyy" value={fechaEntrega} onChange={handleChangeEntrega}
                                                renderInput={(params) => <TextField className="event" {...params} />}
                                />
                            </Grid>
                            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                                <TimePicker label="Time"
                                                value={time}
                                                onChange={handleChangeTime}
                                                renderInput={(params) => <TextField {...params} />}
                                />
                            </Grid>
                        </LocalizationProvider>
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                            <Button onClick={createTarea} 
                                    disabled={titulo !== '' && descripcion !== '' ? false : true}>
                                    Agregar
                            </Button>
                        </Grid>
                    </Grid>
                </FormControl>
                </Box>
            </Modal>
        </React.Fragment>
    );
}

export { TasksControls };